export default {
  en: {
    TeamEditScene: {
      title: 'Edit user',
    },
  },
};
